import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { getSubscriptionDiscounts, getSubscriptionDiscountsSuccess } from './subscription-discounts.actions';
import { SubscriptionDiscountsApiService } from '../services/subscription-discounts-api.service';

@Injectable()
export class SubscriptionDiscountsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly subscriptionDiscountsApiService: SubscriptionDiscountsApiService,
  ) {}

  getSubscriptionDiscounts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getSubscriptionDiscounts),
      switchMap(() =>
        this.subscriptionDiscountsApiService
          .fetchSubscriptionDiscounts()
          .pipe(map(discounts => getSubscriptionDiscountsSuccess({ discounts }))),
      ),
    ),
  );
}
